export interface IConfig {
  HOME_PATH: string;
}

export const config: IConfig = {
  HOME_PATH: "/orders",
};
